import { GrAnnounce } from "react-icons/gr";
import { FaPlus } from "react-icons/fa6";
import Button from "../../../components/ui/Button";
import { strings } from "../../../strings/strings";

const EmptyState = ({ onAddAnnouncement }) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 sm:py-12 lg:py-16 px-4">
      <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mb-4 sm:mb-6">
        <GrAnnounce className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-gray-400" />
      </div>
      
      <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-900 dark:text-white mb-2 text-center">
        {strings.NO_ANNOUNCEMENTS}
      </h3>
      
      <p className="text-sm sm:text-base text-gray-500 dark:text-gray-400 text-center mb-6 sm:mb-8 max-w-sm sm:max-w-md px-2">
        {strings.EMPTY_ANNOUNCEMENT_DESCRIPTION}
      </p>
      
      <Button 
        onClick={onAddAnnouncement}
        className="w-max xs:w-auto text-sm sm:text-base"
      >
        <FaPlus className="w-4 h-4 mr-2" />
        <span className="hidden xs:inline">{strings.CREATE_FIRST_ANNOUNCEMENT}</span>
        <span className="xs:hidden">{strings.CREATE_FIRST_ANNOUNCEMENT}</span>
      </Button>
    </div>
  );
};

export default EmptyState;